// extracted by mini-css-extract-plugin
export var chevron = "_ip-2";
export var dropdownItems = "_ip-0";
export var item = "_ip-1";